import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { RoleLevel } from '../services/settingService/setting.enum';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {
 
  customize: boolean = true;
  expand: boolean = false;
 
  rolesAsssign: any[] = [];
  navItems: any[] = [];
  isOfficeAdmin: boolean;
  isOrganizationAdmin: boolean;
  isSuperAdmin: boolean;

  constructor(private _dataSharingService: DataSharingService) {

  }

  ngOnInit(): void {
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

    //
    if (this.rolesAsssign.length > 0) {
      this.isOfficeAdmin = this.rolesAsssign.find(m => m.roleName == 'Office Admin') != undefined;
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }
    //

    if(this.rolesAsssign.length > 0){
      var Superadmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      Superadmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(Superadmin.length > 0){
       this.ManageFeilds();
       this.ManageSharedRole();
       this.ManageTemplateCategory();
       this.ManageOrganizationTemplateCategory();
       this.ManageAITemplates();
       this.ManageMessageTemplates();      
       //this.ManageMessageTemplates();
       this.ManageImportExport();
       //this.ManageLoginDetails();
        return;
      }

      var OrganizationAdmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      OrganizationAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin);
      if(OrganizationAdmin.length > 0){       
        this.ManageFeilds();   
        this.ManageSharedRole();
        this.ManageOrganizationTemplateCategory();
       // this.ManageTemplates();    
        this.ManageAITemplates();   
        this.ManageMessageTemplates();
        this.ManageImportExport();
        return;
      }

      var OfficeAdmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      OfficeAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
      if(OfficeAdmin.length > 0){        
        this.ManageFeilds();
        this.ManageSharedRole();
        this.ManageOrganizationTemplateCategory();
        //this.ManageTemplates();       
        this.ManageAITemplates(); 
        this.ManageMessageTemplates();
        this.ManageImportExport();
        return;
      }    

      var User=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      User= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.User);
      if(User.length > 0){
        this.ManageTemplates();
        this.ManageAITemplates();
        this.ManageImportExport();
        return;
      }
    }   
  }
  
   // Show only Super admin / Organization Admin / OfficeAdmin
   ManageFeilds(){
    var ReqModel={
    id: '1',
    name : 'Customize',
    items :[
      {
        name: 'Manage Fields',
        link: '/settings',
      },
      {
        name: 'Manage Sub Types',
        link: 'subtype',
      },
      {
        name: 'Manage Tags',
        link: 'managetag',
      },
      {
        name: 'Manage Relation',
        link: 'managetransactionroles',
      },
      {
        name: 'Manage Task Status',
        link: 'managetaskstatus',
      },
      {
        name: 'Manage Activity Status',
        link: 'manageactivitystatus',
      },
      {
        name: 'Manage Custom Info Description',
        link: 'managecustominfostatus',
      },
      {
        name: 'Manage Folder',
        link: 'managefolderform',
      },
      {
        name: 'Manage Quick Web Forms',
        link: 'managefolderforms',
      },
      {
        name: 'Manage NTA',
        link: 'managentacomorbidity',
      }
    ]
    } 
    this.navItems.push(ReqModel);
   }

   // Show For All Login
   ManageTemplates(){
    var ReqModel={
      id: '2',
      name : 'Manage Templates',
      items :[
        {
          name: 'Document List Templates',
          link: 'managetemplates',
        },
        {
          name: 'Task List Templates',
          link: 'managetasktemplates',
        },
        {
          name: 'Single Task Templates',
          link: 'managesingletasktemplates',
        },       
        // {
        //   name: 'OCR Templates',
        //   link: 'manageOcrTemplate',
        // },
        {
          name: 'Email Templates',
          link: 'emailtemplate',
        },       
        // {
        //   name: 'NLP Template',
        //   link: 'manageQuestionTemplate',
        // },
        // {
        //   name: 'AI Automation Templates',
        //   link: 'manageAIAutomationTemplates',
        // },
        // {
        //   name: 'Import Records',
        //   link: 'import',
        // },        
      ] 
     }   
      this.navItems.push(ReqModel);    
   }

    // Show For All Login
    ManageImportExport(){
      var ReqModel={
        id: '2',
        name : 'API Mappings',
        items :[          
          {
            name: 'Upload by CSV',
            link: 'import',
          },
          // {
          //   name: "3rd Party API's ",
          //   link: 'thirdparty',
          // },
          {
            name: "Integrations",
            link: 'addthirdParty',
          },     
        ] 
       }   
        this.navItems.push(ReqModel);    
     }

    // Show For Office Login
    ManageMessageTemplates(){
      var ReqModel={
        id: '2',
        name : 'Manage Templates',
        items :[
          {
            name: 'Document List Templates',
            link: 'managetemplates',
          },
          // {
          //   name: 'Import Records',
          //   link: 'import',
          // },
          {
            name: 'Message Templates',
            link: 'messagetemplates',
          },          
          {
            name: 'Task List Templates',
            link: 'managetasktemplates',
          },
          {
            name: 'Single Task Templates',
            link: 'managesingletasktemplates',
          },          
          // {
          //   name: 'OCR Templates',
          //   link: 'manageOcrTemplate',
          // },
          {
            name: 'Email Templates',
            link: 'emailtemplate',
          }, 
          
              

          // {
          //   name: 'NLP Template',
          //   link: 'manageQuestionTemplate',
          // },          
        ] 
       }   
        this.navItems.push(ReqModel);    
     }

   // Show only Super admin
   ManageTemplateCategory(){
    var ReqModel={
      id: '3',
      name : 'Category',
      items :[          
        {
          name: 'All Master Category',
          link: 'templatecategory',
        },
        {
          name: 'Template Category',
          link: 'templatecategoryOrg',
        },
        {
         name: 'Task Category',
         link: 'managetaskcategory',
         }
        ],
     } 
     this.navItems.push(ReqModel);    
   }

   ManageOrganizationTemplateCategory(){
    var ReqModel={
      id: '3',
      name : 'Template Category',
      items :[        
        {
          name: 'Template Categories',
          link: 'templatecategoryOrg',
        },
        {
          name: 'OCR Templates Category',
          link: 'manageOcrTemplateCategory',
        },
        {
          name: 'NLP Template Category',
          link: 'manageQuestionTemplateCategory',
        },
        ],
     } 
     this.navItems.push(ReqModel);    
   }

   
     // Show only Super admin
     ManageLoginDetails(){
      var ReqModel={
        id: '5',
        name : 'All Login Details',
        items :[          
          {
            name: 'Login Details',
            link: 'logindetails',
          }
          ],
       } 
       this.navItems.push(ReqModel);    
     }

   // Show only Organization Admin
   ManageSharedRole(){
    var ReqModel={
      id: '4',
      name : 'Manage Shared Role',
      items :[          
        {
          name: 'Shared Roles',
          link: 'managesharedrole',
        },          
       ] 
      }
     this.navItems.push(ReqModel);    
   }


   ManageAITemplates(){
    var ReqModel={
      id: '22',
      name : 'Manage AI Templates',
      items :[            
        {
          name: 'AI Field Template',
          link: 'manageOcrTemplate',
        },              
        {
          name: 'AI Question Template',
          link: 'manageQuestionTemplate',
        },
        {
          name: 'AI Automation Templates',
          link: 'manageAIAutomationTemplates',
        }, 
        {
          name: 'Automation Process Report',
          link: 'manageAutomationProcessReport',
        },  
        {
          name: 'System Prompts',
          link: 'systemprompts',
        }           
      ] 
     }   
      this.navItems.push(ReqModel);    
   }
   
   
   
  expandNav(){
    this.expand = !this.expand
  }


  

  linkclick(link){    
    if(link.name == "My Profile"){
      sessionStorage.setItem('HeaderModuleName', link.name);   
      this._dataSharingService.sendSelectedModuleName(link.name);
    }   
  }

}


